import { defineComponent as _defineComponent } from 'vue'
import Reservation from '@/model/Reservation';
import {
  computed, PropType,
} from 'vue';
import {
  History, HistoryItem, HistoryItemType, HistoryItemSubtype, HistoryItemFlag, historyToItems,
} from '@/services/reservation-history';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationHistoryDialog',
  props: {
  reservation: { type: Object as PropType<Reservation>, required: true },
  history: { type: Object as PropType<History>, required: true },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const items = computed(() => historyToItems(props.reservation, props.history));

const historyIncomplete = computed(() => (props.reservation.dateCreated || new Date()) < new Date(2022, 7, 24));

function iconForItem(item: HistoryItem): string {
  switch (item.subtype) {
    case HistoryItemSubtype.Created:
      // eslint-disable-next-line no-bitwise
      if (item.flags & HistoryItemFlag.TypeOnline) { return 'mdi-earth-plus'; }
      return 'mdi-file-document-plus-outline';
    case HistoryItemSubtype.Modified: return 'mdi-file-document-edit-outline';
    case HistoryItemSubtype.Email:
      /* eslint-disable no-bitwise */
      if (item.flags & HistoryItemFlag.StatusDelivered) { return 'mdi-email-fast-outline'; }
      if (item.flags & HistoryItemFlag.StatusBounced) { return 'mdi-email-alert-outline'; }
      if (item.flags & HistoryItemFlag.StatusUndeliverable) { return 'mdi-email-alert-outline'; }
      if (item.flags & HistoryItemFlag.StatusSend) { return 'mdi-email-fast-outline'; }
      return 'mdi-email-alert-outline';
      /* eslint-enable no-bitwise */
    case HistoryItemSubtype.SMS:
      /* eslint-disable no-bitwise */
      if (item.flags & HistoryItemFlag.StatusDelivered) { return 'mdi-message-fast-outline'; }
      if (item.flags & HistoryItemFlag.StatusUndeliverable) { return 'mdi-message-alert-outline'; }
      if (item.flags & HistoryItemFlag.StatusSend) { return 'mdi-message-fast-outline'; }
      return 'mdi-message-alert-outline';
      /* eslint-enable no-bitwise */
    default: return '';
  }
}

function colorForItem(item: HistoryItem): string {
  switch (item.type) {
    case HistoryItemType.Record: return 'blue';
    case HistoryItemType.Message: {
      /* eslint-disable no-bitwise */
      if (item.flags & HistoryItemFlag.StatusDelivered) { return 'green'; }
      if (item.flags & HistoryItemFlag.StatusBounced) { return 'red'; }
      if (item.flags & HistoryItemFlag.StatusUndeliverable) { return 'red'; }
      if (item.flags & HistoryItemFlag.StatusSend) { return 'green'; }
      return 'red';
      /* eslint-enable no-bitwise */
    }
    default: return 'blue';
  }
}

return { __sfc: true,props, emit, items, historyIncomplete, iconForItem, colorForItem }
}

})